'use strict';

import requestTpl from './forgot-password-request.html';
import successTpl from './forgot-password-success.html';

class ForgotPasswordController {
    /* @ngInject */
    constructor($mdToast, UsersService, LoginService,
                $templateCache, $state) {
        Object.assign(this, {$mdToast, UsersService, LoginService, $state});
        $templateCache.put('forgot-password-request.html', requestTpl);
        $templateCache.put('forgot-password-success.html', successTpl);
        this.template = 'forgot-password-request.html';
    }

    request() {
        if (this.form.$valid) {
            this.showSpin = true;
            this.UsersService.resetPassword({
                email: this.email
            }).then(() => {
                this.template = 'forgot-password-success.html';
            }, err => {
                this.showSpin = false;
                if (err.data.error.code === 'EMAIL_NOT_FOUND') {
                    // Do not undisclose if email does not exist
                    this.template = 'forgot-password-success.html';
                } else {
                    let msg = 'Ocurrio un error. Por favor contacte con IRT';
                    this.$mdToast.show(
                        this.$mdToast.simple()
                            .content(msg)
                            .position('top left')
                            .hideDelay(3000)
                            .parent('forgot-password')
                            .toastClass('error')
                    );
                }
                console.error(err);
            });
        }
    }
}

export default ForgotPasswordController;
